import React from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect(process.env.REACT_APP_SOCKET_URL); // connect socket
socket.on("connect", () => {
  // console.log(`connected :id : ${socket.id}`);
});
export const SocketContext = React.createContext();
